export enum TransferType {
  Internal = 'internal',
  External = 'external'
}
